import React, { useState } from "react";
import { Container, Grid, Box } from "@mui/material";
import List from "./inc/List";
import AddForm from "./inc/AddForm";
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import { faBarChart } from "@fortawesome/free-solid-svg-icons";

const CcpAdminFaqs = () => {
  const [listRefresh, setListRefresh] = useState(false);

  const pageName = "FAQs";
  const icon = faBarChart;

  const handleAdd = () => {
    setListRefresh(!listRefresh);
  };

  return (
    <Container sx={{ marginTop: "100px" }}>
      <CcpAdminBreadCrumbs pageName={pageName} icon={icon} />
      <Box sx={{ flexGrow: 1, marginTop: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <AddForm onAdd={handleAdd} />
          </Grid>
          <Grid item xs={12} md={8}>
            <List key={listRefresh.toString()} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpAdminFaqs;
